import {useFeatureFlags} from '@smart/feature-app';
import type {TextButtonProps} from '@smart/web-components';
import {TextButton} from '@smart/web-components';
import * as React from 'react';
import type {Sorting} from '../../../bff/types';
import {UsedFeatureFlags} from '../../constants/common';
import type {SelectProps} from '../sort-by-select';
import {Select as SortBySelect} from '../sort-by-select';
import styles from './index.module.scss';
export type FilterButtonsProps = {
  filterButton: Omit<
    TextButtonProps,
    'variant' | 'iconName' | 'size' | 'iconPosition'
  >;
  resetButton: Omit<
    TextButtonProps,
    'variant' | 'iconName' | 'size' | 'iconPosition'
  >;
  sortByButton: {
    label: string;
    onChange: SelectProps['onChange'];
    value: string;
    options: {
      label: string;
      value: Sorting;
    }[];
  };
  filterLength: number;
};

export const FilterButtons = ({
  filterButton,
  resetButton,
  sortByButton,
  filterLength,
}: FilterButtonsProps): JSX.Element => {
  const baseClass = `filter-buttons`;
  const {enabled: enableFilters} = useFeatureFlags(
    UsedFeatureFlags.ENABLE_STOCK_SEARCH_FILTER_V2,
  );

  return (
    <div className={styles[baseClass]}>
      {filterLength ? (
        <TextButton
          className={styles[`filter-reset-button`]}
          {...resetButton}
          variant="ghost"
          iconName="close-with-circle--small"
          size="200"
          iconPosition="left"
        />
      ) : null}
      {enableFilters ? null : (
        <>
          <TextButton
            {...filterButton}
            className={styles[`filter-button`]}
            variant="secondary"
            iconName="filter--small"
            size="200"
            iconPosition={`left`}
          />

          <SortBySelect
            autoComplete="on"
            id="sort-by"
            name="sort-by"
            {...sortByButton}
          />
        </>
      )}
    </div>
  );
};
